import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface UnlinkAllSupplementaryReportsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export const UnlinkAllSupplementaryReportsDialog = ({
  isOpen,
  onClose,
  onConfirm,
}: UnlinkAllSupplementaryReportsDialogProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Unlink All Supplementary Reports</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to unlink all supplementary reports from this
          report?
        </DialogContentText>
        <DialogContentText>
          <br />
          All supplementary reports will be converted to standalone reports.
        </DialogContentText>
      </DialogContent>
      <DialogActions
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "16px",
        }}
      >
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={() => {
            onConfirm().then(() => {
              onClose();
            });
          }}
          color="primary"
          variant="contained"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
